import { Quote } from "lucide-react";

import type { MessageAction } from "~/components/MessageActions";

export function buildQuoteAction({ onClick }: { onClick: () => void }): MessageAction {
  return {
    id: "quote",
    label: "Quote",
    icon: Quote,
    onClick,
  };
}
